import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import makeStyles from "@material-ui/core/styles/makeStyles";
import { Add } from "@material-ui/icons";
import Create from "@material-ui/icons/Create";
import GridContainer from "@jumbo/components/GridContainer";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { fetchError } from "redux/actions";
import EventsRequests from "services/events";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";
import ImagePicker from "@jumbo/Dashboards/Tests/compnents/ImagePicker";
import {
  TextField,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import CheckBox from "@jumbo/Dashboards/Banner/CheckBox";
import CustomSelect from "@jumbo/Dashboards/Banner/CustomSelect";

import ListAltIcon from "@material-ui/icons/ListAlt";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import HelpIcon from "@material-ui/icons/Help";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import PostAddIcon from "@material-ui/icons/PostAdd";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import ContactSupportOutlinedIcon from "@material-ui/icons/ContactSupportOutlined";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import LocalLibraryOutlinedIcon from "@material-ui/icons/LocalLibraryOutlined";
import BookmarkBorderOutlinedIcon from "@material-ui/icons/BookmarkBorderOutlined";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import CreateIcon from "@material-ui/icons/Create";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  cardRoot: {
    paddingTop: "24px",
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
    paddingInline: "25px",
  },
  formContainer: {
    width: "100%",
  },
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  buttonContainer: {
    paddingInline: "40px !important",
    justifyContent: "flex-end",
  },
  label: {
    marginBottom: 20,
    fontWeight: "500",
  },
}));

const EventFields = () => {
  const [eventTitle, setEventTitle] = useState("");
  const [eventDesc, setEventDesc] = useState("");
  const [eventSubTitle, setEventSubTitle] = useState("");
  const [eventPoster, setEventPoster] = useState("");
  const [archived, setArchived] = useState(false);
  const [eventIcon, seteventIcon] = useState("");
  const [openFileUploader, setOpenFileUploader] = useState(false);

  const [accessList, setAccessList] = useState(false);
  const [accessListTopic, setAccessListTopic] = useState("");
  const [accessListType, setAccessListType] = useState("");
  const [blackAccessList, setBlackAccessList] = useState(false);
  const [blackAccessListTopic, setBlackAccessListTopic] = useState("");
  const [blackAccessListType, setBlackAccessListType] = useState("");
  const [blackAccessListError, setBlackAccessListError] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { singleEvent } = useSelector(({ events }) => events);

  useEffect(() => {
    if (id) {
      dispatch(EventsRequests.getEventById(id));
    }
  }, [id]);

  useEffect(() => {
    if (singleEvent) {
      if (singleEvent.event._id === id) {
        setEventTitle(singleEvent.event.name);
        setEventDesc(singleEvent.event.description);
        setEventSubTitle(singleEvent.event?.subtitle);
        setEventPoster(singleEvent.event?.poster);
        setArchived(singleEvent.event?.archived);
        seteventIcon(singleEvent.event?.icon);
        // Access List
        setAccessList(singleEvent.event?.limits?.accessList || false);
        setAccessListTopic(singleEvent.event?.limits?.accessListTopic || "");
        setAccessListType(singleEvent.event?.limits?.accessListType || "");

        // Black Access List
        setBlackAccessList(singleEvent.event?.limits?.blackList || false);
        setBlackAccessListTopic(
          singleEvent.event?.limits?.blackListTopic || ""
        );
        setBlackAccessListType(singleEvent.event?.limits?.blackListType || "");
        setBlackAccessListError(
          singleEvent.event?.limits?.blackListError || ""
        );
      }
    }
  }, [singleEvent]);

  const handleCreateTest = () => {
    if (eventDesc || eventTitle) {
      const createdEvent = {
        name: eventTitle,
        description: eventDesc,
        subtitle: eventSubTitle,
        poster: eventPoster,
        archived: archived,
        icon: eventIcon,
      };
      const limits = {
        accessList: accessList,
        blackList: blackAccessList,
      };
      if (accessList) {
        limits["accessListTopic"] = accessListTopic;
        limits["accessListType"] = accessListType;
      }
      if (blackAccessList) {
        limits["blackListTopic"] = blackAccessListTopic;
        limits["blackListType"] = blackAccessListType;
        limits["blackListError"] = blackAccessListError;
      }
      createdEvent["limits"] = limits;
      dispatch(EventsRequests.createSingleEvent(createdEvent));
      setEventTitle("");
      setEventDesc("");
      setEventSubTitle("");
      setEventPoster("");
      setArchived(false);
    } else {
      dispatch(fetchError("موارد لازم را به درستی وارد نمایید"));
    }
  };

  const handleUpdateEvent = () => {
    if (eventDesc || eventTitle) {
      const updatedEvent = {
        name: eventTitle,
        description: eventDesc,
        subtitle: eventSubTitle,
        poster: eventPoster,
        archived: archived,
        icon: eventIcon,
      };
      const limits = {
        accessList: accessList,
        blackList: blackAccessList,
      };
      if (accessList) {
        limits["accessListTopic"] = accessListTopic;
        limits["accessListType"] = accessListType;
      }
      if (blackAccessList) {
        limits["blackListTopic"] = blackAccessListTopic;
        limits["blackListType"] = blackAccessListType;
        limits["blackListError"] = blackAccessListError;
      }
      updatedEvent["limits"] = limits;
      dispatch(EventsRequests.updateEvent(id, updatedEvent));
    } else {
      dispatch(fetchError("موارد لازم را به درستی وارد نمایید"));
    }
  };

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <form className={classes.formContainer} noValidate autoComplete="off">
          <GridContainer className={classes.girdContainer}>
            <Grid item xs={12}>
              <Typography className={classes.label}>نام رخداد</Typography>
              <TextField
                id="eventNameField"
                label="نام رخداد"
                variant="outlined"
                className={classes.customInput}
                value={eventTitle}
                onChange={(e) => setEventTitle(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.label}>زیر‌عنوان</Typography>
              <TextField
                id="subtitleField"
                label="زیر‌عنوان"
                variant="outlined"
                className={classes.formControl}
                value={eventSubTitle}
                onChange={(e) => setEventSubTitle(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.label}>انتخاب پوستر</Typography>
              <ImagePicker
                cover={eventPoster}
                handlePick={() => setOpenFileUploader(true)}
                handleRevome={() => setEventPoster("")}
                previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
                placeHolderStyles={{
                  marginInline: "auto",
                  marginBlock: "20px",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.label}>توضیحات رخداد</Typography>
              <TextField
                id="eventDescField"
                multiline
                minRows={4}
                label="توضیحات"
                variant="outlined"
                className={classes.customInput}
                value={eventDesc}
                onChange={(e) => setEventDesc(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <CheckBox
                name={"archived"}
                title={"آرشیو"}
                value={archived}
                handleChange={(e) => setArchived(e.target.checked)}
              />
            </Grid>

            <Grid item xs={12}>
              <CheckBox
                name={"accessLimit"}
                title={"لیست سفید دسترسی"}
                value={accessList}
                handleChange={() => setAccessList(!accessList)}
              />
            </Grid>
            {accessList && (
              <>
                <Grid item xs={12} md={7}>
                  <Typography className={classes.label}>
                    محدودیت دسترسی
                  </Typography>
                  <TextField
                    id="accessListTopic"
                    label="محدودیت دسترسی"
                    variant="outlined"
                    className={classes.formControl}
                    value={accessListTopic}
                    onChange={(e) => setAccessListTopic(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={7}>
                  <CustomSelect
                    title={"نوع دسترسی"}
                    value={accessListType}
                    handleChange={(val) => setAccessListType(val)}
                    options={[
                      { value: "CodeMeli", text: "کد ملی" },
                      { value: "CodePersoneli", text: "کد پرسنلی" },
                    ]}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <CheckBox
                name={"blackAccessLimit"}
                title={"لیست سیاه دسترسی"}
                value={blackAccessList}
                handleChange={() => setBlackAccessList(!blackAccessList)}
              />
            </Grid>
            {blackAccessList && (
              <>
                <Grid item xs={12} md={7}>
                  <Typography className={classes.label}>
                    محدودیت دسترسی
                  </Typography>
                  <TextField
                    id="blackAccessListTopic"
                    label="محدودیت دسترسی"
                    variant="outlined"
                    className={classes.formControl}
                    value={blackAccessListTopic}
                    onChange={(e) => setBlackAccessListTopic(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={7}>
                  <Typography className={classes.label}>
                    متن خطای دسترسی
                  </Typography>
                  <TextField
                    id="blackAccessListError"
                    label="متن خطای دسترسی"
                    variant="outlined"
                    className={classes.formControl}
                    value={blackAccessListError}
                    onChange={(e) => setBlackAccessListError(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={7}>
                  <CustomSelect
                    title={"نوع دسترسی"}
                    value={blackAccessListType}
                    handleChange={(val) => setBlackAccessListType(val)}
                    options={[
                      { value: "CodeMeli", text: "کد ملی" },
                      { value: "CodePersoneli", text: "کد پرسنلی" },
                    ]}
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} md={7}>
              <Typography className={classes.label}>آیکون فرم</Typography>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">
                  آیکون فرم
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={eventIcon}
                  onChange={(e) => seteventIcon(e.target.value)}
                  label={"آیکون فرم"}
                >
                  <MenuItem value={"first"}>
                    <AccountBalanceIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"second"}>
                    <CreateIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"third"}>
                    <ListAltIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"forth"}>
                    <HelpOutlineIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"fifth"}>
                    <HelpIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"sixth"}>
                    <ImportContactsIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"seventh"}>
                    <MenuBookIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"eighth"}>
                    <CreditCardIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"ninth"}>
                    <PermIdentityIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"thenth"}>
                    <PostAddIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"twelveth"}>
                    <CreateOutlinedIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"thirteenth"}>
                    <KeyboardArrowDownIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"forteenth"}>
                    <ContactPhoneOutlinedIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"fifteenth"}>
                    <ContactSupportOutlinedIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"sixteenth"}>
                    <PermIdentityOutlinedIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"seventeenth"}>
                    <LocalLibraryOutlinedIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                  <MenuItem value={"eigtheen"}>
                    <BookmarkBorderOutlinedIcon
                      fontSize="small"
                      style={{ marginBottom: "-5px" }}
                    />
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} container className={classes.buttonContainer}>
              {id ? (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    startIcon={<Create />}
                    onClick={handleUpdateEvent}
                  >
                    ویرایش رخداد
                  </Button>
                  {/* <Button variant="contained" color="primary" size="medium" startIcon={<Add />} onClick={handleCreateTest}>
                    ویرایش سانس ها
                  </Button> */}
                </>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  startIcon={<Add />}
                  onClick={handleCreateTest}
                >
                  ساخت رخداد
                </Button>
              )}
            </Grid>
          </GridContainer>
        </form>
      </CmtCardContent>
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) => setEventPoster(selected)}
        selectedItem={eventPoster}
        imageSelector={true}
      />
    </CmtCard>
  );
};

export default EventFields;
